import Vue from "vue"
import Vuex from "vuex"
import {cacheSrv} from "./../libs/cache/cache"
import eventBus from "./../eventBus"
import {config} from "./../libs/utils"

Vue.use(Vuex)

interface TooltipState {
  content: {[key: string]: any}
  lockedFields: string[]
  loadedPrefix: string | null
}

export default new Vuex.Store({
  state: {
    notifications: 0,
    serviceWorkerRegistration: null,
    lastLink: cacheSrv.cached("last-link") || 0,
    token: "",
    profile: {},
    cacheFilters: {},
  },
  mutations: {
    incNotifications(state, count) {
      console.log("state.notifications = state.notifications + 1", count)
      if (count > 0) {
        state.notifications = state.notifications + 1
      } else {
        state.notifications = 0
      }
    },
    setServiceWorkerRegistration(state, swr) {
      state.serviceWorkerRegistration = swr
    },
    updateLastLink(state, linkIndex) {
      state.lastLink = linkIndex
      cacheSrv.cache("last-link", linkIndex)
    },
    updateProfile(state, profile) {
      state.profile = profile
      eventBus.$emit("user-session-event", profile)
    },
    updateToken(state, token) {
      state.token = token
    },
    logout(state, value) {
      console.log("Store cleaned")
      state.token = ""
      state.profile = {}
      state.lastLink = 0
    },
  },
  getters: {
    profile: (state) => {
      let profile = state.profile
      return profile
    },
    lastLink: (state) => {
      return state.lastLink
    },
    token: (state) => {
      return state.token
    },
    serviceWorkerRegistration: (state) => {
      return state.serviceWorkerRegistration
    },
  },
  actions: {
    incNotifications(context, val) {
      context.commit("incNotifications", val)
    },
    setServiceWorkerRegistration(context, val) {
      context.commit("setServiceWorkerRegistration", val)
    },
    updateLeftMenu(context, val) {
      context.commit("updateLeftMenu", val)
    },
    updateLastLink(context, val) {
      context.commit("updateLastLink", val)
    },
  },
  modules: {
    subscription: {
      namespaced: true,
      state: {
        lockedFields: [],
      },
      mutations: {
        lockedFields(state, fields) {
          state.lockedFields = fields
        },
      },
      getters: {
        lockedFields: (state) => {
          return state.lockedFields
        },
      },
      actions: {
        async loadLockedFields(context) {
          try {
            const response = await import(`@/assets/contents/${config.VUE_APP_PLOT_NUMBER_PREFIX.toLowerCase()}/locked.json`)
            const fields = response || []
            context.commit("lockedFields", fields.locked)
            return fields.locked
          } catch (error) {
            console.error("Error loading locked fields JSON:", error)
            context.commit("lockedFields", [])
            return []
          }
        },
        getLockedFields(context) {
          return context.state.lockedFields
        }
      },
    },
    tooltip: {
      namespaced: true,
      state: {
        content: {},
        loadedPrefix: null,
      } as TooltipState,
      mutations: {
        setTooltipContent(state: TooltipState, payload: {content: {[key: string]: any}; loadedPrefix: string | null}) {
          state.content = payload.content
          state.loadedPrefix = payload.loadedPrefix
        },
      },
      actions: {
        async loadTooltipContent(context: any) {
          const activePrefixCode = config.VUE_APP_PLOT_NUMBER_PREFIX.toLowerCase()

          if (context.state.loadedPrefix === activePrefixCode) {
            return context.state.content
          }

          try {
            const response = await import(`@/assets/contents/${activePrefixCode}/tooltip.json`)
            const content = response.plotInfo || {}
            context.commit("setTooltipContent", {content: content, loadedPrefix: activePrefixCode})
            // console.log("Tooltip content loaded and stored", activePrefixCode, content)

            

            return content
          } catch (error) {
            console.error("Error loading tooltip content JSON:", error)
            context.commit("setTooltipContent", {content: {}, loadedPrefix: null})
            return {}
          }
        },

        // New helper action: load if needed and return a single content entry
        async getTooltipContent(context: any, contentCode: string) {
          // ensure JSON is loaded for the active prefix
          //await context.dispatch("loadTooltipContent")
          // console.log("Getting tooltip content for code:", contentCode)
          return (context.state.content && context.state.content[contentCode]) || {}
        },
      },
      getters: {
        getTooltipContent:
          (state: TooltipState) =>
          (contentCode: string): any => {
            if (!state.content) {
              // console.log("Tooltip content not loaded yet.")
              return {}
            }
            return state.content[contentCode] || {}
          },
      },
    },
  },
})
